import { render, staticRenderFns } from "./numberComponent.vue?vue&type=template&id=6abc8cf9&scoped=true&"
import script from "./numberComponent.vue?vue&type=script&lang=js&"
export * from "./numberComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abc8cf9",
  null
  
)

export default component.exports